import { render, staticRenderFns } from "./WaitingValuesAdd.vue?vue&type=template&id=6482861d&scoped=true&"
import script from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesAdd.vue?vue&type=style&index=0&id=6482861d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6482861d",
  null
  
)

export default component.exports